import React from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import '../style-rtl.scss'
export const Loading = () => {
    const cards = new Array(6).fill(0)
    return (
        <div className='loading-card-container'>
            {cards.map((element, index) => {
                return (
                    <div key={index} className='loading-card'>
                        <div className="card-content">
                            <div className="image">
                                <Skeleton width={80} height={80} borderRadius={12} />
                            </div>
                            <div className="details">
                                <Skeleton className='title' height={20}/>
                                <Skeleton className="description" height={10} count={3} />
                            </div>
                        </div>
                        <div className="card-footer">
                            <Skeleton height={20} width={80} />
                            <Skeleton height={20} width={60} />
                        </div>
                    </div>
                )
            })}
        </div>
    )
}
